<template>
    <div>
        <!-- 弹窗 -->
        <el-dialog width="400px" height="600px" :append-to-body="true" :before-close="handleClose" :visible.sync="dialogFormVisible">
            <div style="margin-top:-25px;">
                <el-row type="flex" justify="center">
                    <h2>{{info.title}}</h2>
                </el-row>
                <el-row type="flex" justify="center">
                    <qrcode-ext ref="qrcode" :qrUrl='info.url?info.url:""' :qrSize='300' qrText="西有设计"></qrcode-ext>
                </el-row>
                <el-row type="flex" justify="center" style="margin-top:30px;">
                    <el-link type="primary" target="_blank" :href="clientUrl">浏览正文</el-link>
                    <el-link type="primary" target="_blank" :href="info.url">访问项目</el-link>
                </el-row>
            </div>
            <!-- 按键操作 -->
            <!-- <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
            </div> -->
        </el-dialog>
    </div>
</template>

<script>
import QrcodeExt from '../../Common/components/QrcodeExt'
import Config from '@/config'

export default {
  components: {
    QrcodeExt,
  },
  props: {
    visiable: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      config: {},
      dialogFormVisible: this.visiable, // 是否弹窗
      clientUrl: '',
    }
  },
  methods: {
    // 弹框 右上角 X
    handleClose(done) {
      this.dialogFormVisible = false
      done()
    },
  },
  watch: {
    visiable(newVal) {
      this.dialogFormVisible = newVal
    },
    dialogFormVisible(newVal) {
      this.$emit('input', newVal)
      if (newVal) {
        this.config = {
          value: this.info.url ? this.info.url : '.',
          filter: 'color',
          imagePath: '',
          width: 300,
          height: 300,
          t: new Date().getTime(),
        }

        this.clientUrl = `${Config.clientUrl}article/${this.info.id}.html`

        this.$nextTick(async () => {
          await this.$refs.qrcode.make()
        })
      }
    },
  },
}
</script>
